module.exports = "<svg height=\"1em\" width=\"1em\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><path d=\"M505.18 123.18c-9.08-9.1-23.82-9.1-32.9 0L256 339.45 39.73 123.18c-9.1-9.1-23.83-9.1-32.9 0-9.1 9.1-9.1 23.82 0 32.9l232.72 232.74c4.36 4.36 10.28 6.82 16.45 6.82 6.18 0 12.1-2.46 16.46-6.82L505.18 156.1c9.1-9.1 9.1-23.83 0-32.92z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/icons/chevron.svg
// module id = ./src/icons/chevron.svg
// module chunks = 21